import produce from 'immer';
import { types } from './types';
import { types as projectTypes } from '../project/types';
import { ITokenBalance, ITokenPackage } from '../../types/global/token.types';
import { ITokenCountdownResponse } from './actions';

export interface ITokenState {
    balance: number;
    token: ITokenBalance | null;
    packages: ITokenPackage[];
    loading: boolean;
    error: string | null;
    purchaseLoading: boolean;
    voteLoading: boolean;
    tokenCountdown?: ITokenCountdownResponse;
}

const initialState: ITokenState = {
    balance: 0,
    token: null,
    packages: [],
    loading: false,
    error: null,
    purchaseLoading: false,
    voteLoading: false,
};

const reducer = (state = initialState, action: any) => {
    const { payload, type } = action;
    switch (type) {
        case types.GET_TOKEN_BALANCE_SUCCESS:
            return produce(state, (draftState: any) => {
                draftState.balance = payload.balance;
                draftState.token = payload.token;
                draftState.loading = false;
                draftState.error = null;
            });
        case types.GET_TOKEN_BALANCE_FAIL:
            return produce(state, (draftState: any) => {
                draftState.loading = false;
                draftState.error = payload.error;
            });
        case types.GET_TOKEN_PACKAGES_SUCCESS:
            return produce(state, (draftState: any) => {
                draftState.packages = payload.packages;
                draftState.loading = false;
                draftState.error = null;
            });
        case types.GET_TOKEN_PACKAGES_FAIL:
            return produce(state, (draftState: any) => {
                draftState.loading = false;
                draftState.error = payload.error;
            });
        case types.PURCHASE_TOKENS:
            return produce(state, (draftState: any) => {
                draftState.purchaseLoading = true;
                draftState.error = null;
            });
        case types.PURCHASE_TOKENS_SUCCESS:
            return produce(state, (draftState: any) => {
                draftState.purchaseLoading = false;
                draftState.error = null;
            });
        case types.PURCHASE_TOKENS_FAIL:
            return produce(state, (draftState: any) => {
                draftState.purchaseLoading = false;
                draftState.error = payload.error;
            });
        case types.CONSUME_TOKENS:
            return produce(state, (draftState: any) => {
                draftState.voteLoading = true;
                draftState.error = null;
            });
        case types.CONSUME_TOKENS_SUCCESS:
            return produce(state, (draftState: any) => {
                draftState.voteLoading = false;
                draftState.error = null;
            });
        case types.CONSUME_TOKENS_FAIL:
            return produce(state, (draftState: any) => {
                draftState.voteLoading = false;
                draftState.error = payload.error;
            });
        case types.GET_TOKEN_COUNTDOWN:
        case types.GET_TOKEN_COUNTDOWN_FAIL:
        case projectTypes.GET_ACTS:
        case projectTypes.GET_PROJECT:
        case projectTypes.GET_PROJECT_DETAIL:
            return produce(state, (draftState: any) => {
                draftState.tokenCountdown = undefined;
            });
        case types.GET_TOKEN_COUNTDOWN_SUCCESS:
            return produce(state, (draftState: any) => {
                draftState.tokenCountdown = payload;
            });
        default:
            return state;
    }
};

export { reducer };
